import { useState } from "preact/hooks"

import { Modal, ModalWrapper } from "src/utils/fw"


export const Leaderboard = () => {
    const [isOpen, setOpen] = useState(false)
    const {
        "Event ID": eventId,
        "Registrant ID": regId,
        "I would like to opt in to the Leaderboard competition": optedIn,
    } = window.dataLayer[0]

    return <div id="Leaderboard" onclick={() => setOpen(!isOpen)}>
        {isOpen && optedIn === "Yes" &&
            <Modal dismiss={(e) => {e.stopPropagation(); setOpen(false)}}><ModalWrapper>
                <iframe style={"width: 30vw; height: 35vh; border: none;"} src={`https://sponsor-gamification.herokuapp.com/leaderboard?eventId=${eventId}&registrantId=${regId}&swoogoAccess=false`} />
            </ModalWrapper></Modal>
        }
    </div>
}